import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';

export function createNewEmbedData(): ManifestInitializedProps {
  const id = genRandId();
  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.Embed],
        ['children', new Y.Array()],
        ['title', ''],
        ['src', '']
      ])
    }
  ];
}
